import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  setCookie(name: string, value: any, days: number) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));

    const expires = "expires=" + d.toUTCString();

    document.cookie =
      name + "=" + encodeURIComponent(JSON.stringify(value)) +
      ";" + expires +
      ";path=/";
  }

  getCookie(name: string): any {
    const cname = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let c of ca) {
      c = c.trim();

      if (c.indexOf(cname) === 0) {
        const value = c.substring(cname.length, c.length);

        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
    }

    return null;
  }

  deleteCookie(name: string) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  }
}
